module.exports = {
  "zones": {
    "Asia/Seoul": ["z", {
      "wallclock": -264902400000,
      "format": "K%sT",
      "abbrev": "KST",
      "offset": 32400000,
      "posix": -264933000000,
      "save": 0,
      "rules": "ROK"
    }, {
      "wallclock": -498096000000,
      "format": "K%sT",
      "abbrev": "KST",
      "offset": 30600000,
      "posix": -498128400000,
      "save": 0,
      "rules": "ROK"
    }, {
      "wallclock": -767318400000,
      "format": "KST",
      "abbrev": "KST",
      "offset": 32400000,
      "posix": -767350800000,
      "save": 0
    }, {
      "wallclock": -1830384000000,
      "format": "JST",
      "abbrev": "JST",
      "offset": 32400000,
      "posix": -1830414600000,
      "save": 0
    }, {
      "wallclock": -1948752000000,
      "format": "KST",
      "abbrev": "KST",
      "offset": 30600000,
      "posix": -1948782472000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 30472000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "ROK": [{
      "from": 1987,
      "to": 1988,
      "month": 4,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1988,
      "month": 9,
      "day": [0, 8],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1957,
      "to": 1960,
      "month": 4,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1957,
      "to": 1960,
      "month": 8,
      "day": [6, 17],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1956,
      "to": 1956,
      "month": 4,
      "day": [7, 20],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1956,
      "to": 1956,
      "month": 8,
      "day": [7, 29],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1955,
      "to": 1955,
      "month": 4,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1955,
      "to": 1955,
      "month": 8,
      "day": [7, 8],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1949,
      "to": 1951,
      "month": 8,
      "day": [6, 7],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1951,
      "to": 1951,
      "month": 4,
      "day": [7, 6],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1950,
      "to": 1950,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1949,
      "to": 1949,
      "month": 3,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1948,
      "to": 1948,
      "month": 5,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1948,
      "to": 1948,
      "month": 8,
      "day": [7, 12],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }]
  }
};